/**
 * @description
 *	Available Face Liveness Detection status.
 *
 * @see https://docs.aws.amazon.com/rekognition/latest/APIReference/API_GetFaceLivenessSessionResults.html
 */
enum LivenessSessionStatus {
	CREATED = "CREATED",
	EXPIRED = "EXPIRED",
	FAILED = "FAILED",
	IN_PROGRESS = "IN_PROGRESS",
	SUCCEEDED = "SUCCEEDED"
}

export default LivenessSessionStatus
